import type { SecuritySettings } from '../types/settings';

type AuthProvider = SecuritySettings['auth_provider'];

/**
 * Human-friendly display names for each authentication provider.
 * Add new SSO providers here as the backend `auth_provider` enum grows.
 */
const PROVIDER_LABELS: Record<AuthProvider, string> = {
  email: 'Email & password',
  google_sso: 'Google',
};

/** Display label for an auth provider; falls back to the raw value if unknown. */
export const authProviderLabel = (provider: AuthProvider | string): string =>
  PROVIDER_LABELS[provider as AuthProvider] ?? provider;

/** True when the provider is an external SSO identity provider (not email/password). */
export const isSsoProvider = (provider: AuthProvider | string): boolean =>
  provider !== 'email';
